import React, {useContext, useEffect, useState} from 'react';
import {IconButton, Tooltip} from '@mui/material';
import Stack from '@mui/material/Stack';
import Dropzone from '../Chat/Dropzone.js';
import {isMobile, matchesAnyRegex} from "../App/utils.js";
import {AlertContext} from "../App/App.js";
import {inputTools} from "./constant.js";
import {uploadFileAPI} from "../API/KB/Files.js";

const types = [/.*/i];
export const UploadFile = ({ style, setBlockingLoading, onSuccess = () => {} }) => {
    const {setSystemAlert} = useContext(AlertContext);

    const onFileUpload = async (event) => {
        const selectedFile = event instanceof File ? event : event.target.files[0];

        if (!selectedFile?.type) return;
        if (!matchesAnyRegex(selectedFile.type, types)) {
            setSystemAlert({msg: 'Invalid file type', type: 'error', duration: 3000})
            return;
        }

        if (!selectedFile) {
            setSystemAlert({msg: 'Please select file to upload', type: 'error', duration: 3000})
            return;
        }

        try {
            setBlockingLoading(1);
            const response = await uploadFileAPI(selectedFile, 'files', (percentage) => {
                setBlockingLoading(percentage);
            });

            let uploadedURL = response?.request?.responseURL?.split('?')?.[0];

            uploadedURL = uploadedURL.replace('https://openkbs-files-raw-accelerate.s3.amazonaws.com', 'https://file.openkbs.com')

            setBlockingLoading(false);

            if (uploadedURL) onSuccess(uploadedURL)

        } catch (e) {
            setBlockingLoading(false)
            alert('Error during upload');
            console.error(e);
        }

        if(event?.target?.value) event.target.value = null;
    }

    return (
        <Stack alignItems="center" spacing={2} style={style} >
            <Dropzone onFileUpload={onFileUpload} types={types} id={"uploadFile"}/>

            <Tooltip title={inputTools.uploadFile.label}>
                <IconButton color="primary" aria-label={inputTools.uploadFile.label} component="label">
                    <input hidden type="file" onChange={onFileUpload} />
                    {isMobile ? inputTools.uploadFile.iconMobile() : inputTools.uploadFile.icon()}
                </IconButton>
            </Tooltip>
        </Stack>
    );
}